import { formatTimeDuration } from '@racemap/utilities/formattings/formatting';
import {
  type Geofence,
  type PreparedStarterInfo,
  sortTimes,
  testEventHasVirtDuration,
} from '@racemap/utilities/functions/timing';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import type { Column } from '../TableBody';
import { Cell } from './BasicCell';
import { LARGE_TIME_COL_WIDTH, SMALL_TIME_COL_WIDTH } from './TimesCol';

function RestDurationColComponent({
  starterInfo,
}: {
  starterInfo: Immutable<PreparedStarterInfo>;
}) {
  const restDuration = starterInfo?.restDuration;

  return (
    <Cell>
      <div>{restDuration > 0 ? formatTimeDuration(restDuration) : ''}</div>
    </Cell>
  );
}

export function getRestDurationCol(
  event: Immutable<RacemapEvent>,
  timekeepings: Immutable<Array<Geofence>>,
  windowWidth: number,
): Column {
  const eventHasVirtDuration = testEventHasVirtDuration(event);

  return {
    key: 'times_finish',
    title: 'Rest Duration',
    width:
      windowWidth < 990 || timekeepings.length > 6 ? SMALL_TIME_COL_WIDTH : LARGE_TIME_COL_WIDTH,
    render: function renderer(row: Immutable<PreparedStarterInfo>) {
      return <RestDurationColComponent starterInfo={row} />;
    },
    sorter: (a: Immutable<PreparedStarterInfo>, b: Immutable<PreparedStarterInfo>) => {
      return eventHasVirtDuration
        ? b?.restDuration - a?.restDuration
        : sortTimes(b?.restDuration, a?.restDuration);
    },
  };
}
